/**
 * @description Converts various types of input into a boolean value.
 * @param {unknown} value - The input value to be evaluated as true or false.
 * @returns {boolean} - Returns true if the input value is recognized as true, otherwise returns false.
 * It recognizes the following as true:
 * - Boolean true
 * - String 'true' (case-insensitive)
 * - String '1'
 * - String 'yes' (case-insensitive)
 * - Number 1
 */
export const isTrue = (value: unknown): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || value === '1' || value.toLowerCase() === 'yes';
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  return false;
};
